module.exports = __webpack_public_path__ + "9b2cc31b75be42d588332e15e8115c0a.svg";